const getCapitalizedText = (value) => {
  return value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : ''
}

export default getCapitalizedText
